// Verdict for a Baseline Comparison "Event Value" cell, evaluated against the
// 7-day and 30-day baseline windows. Each `match` argument is:
//   true  — the event value is in that window's baseline
//   false — that window HAS baseline data and the event value is NOT in it
//   null  — that window has no baseline data for this field (nothing to compare)
//
// Color policy (requested 2026-09-12):
//   green — matches the 30-day norm (the established, longer-term behaviour)
//   amber — matches ONLY the recent 7-day window; the 30-day norm has data and
//           disagrees. This is the "recent only" signal: legitimate travel /
//           relocation, OR a 7-day window already contaminated by the very
//           activity under investigation. Worth a second look, not a hard miss.
//   red   — matches neither window that has data (a genuine deviation)
//   gray  — no baseline data in either window to compare against
//
// When the 30-day window carries NO data (match30 === null) we fall back to the
// 7-day window rather than forcing amber — otherwise an older alert that only
// ever had a 7-day snapshot would paint every matching row "partial".
export function baselineVerdict(match7, match30) {
  if (match30 === true) return 'green';
  if (match30 === false) return match7 === true ? 'amber' : 'red';
  // match30 === null → no 30-day data; decide on the 7-day window alone.
  if (match7 === true) return 'green';
  if (match7 === false) return 'red';
  return 'gray';
}

const CLASS_BY_VERDICT = {
  green: 'text-green-400 font-mono',
  amber: 'text-amber-400 font-mono',
  red: 'text-red-400 font-mono',
  gray: 'text-gray-300 font-mono',
};

// Tailwind class for the Event Value cell. Rows that carry their own
// `eventClass` (IP-in-baseline subnet logic, Device-in-DRMM) bypass this.
export function baselineEventCellClass(match7, match30) {
  return CLASS_BY_VERDICT[baselineVerdict(match7, match30)];
}
